<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="event-box mdc-card" v-if="show">
		<!-- BOX -->
		<div v-show="showSection" class="event-box__container mdc-card__horizontal-block" :class="{'mq-sm-show': showMore}">
			<div class="event-box__color-type"></div>

			<div class="event-box__content">
				<!-- Image -->
				<a :href="'/properties/' + property.propertyId" class="mq-md-hidden event-box__image" :class="{'event-box__image--none': property.mainImage === '' || property.mainImage === null || property.mainImage === undefined}" v-bind:style="{backgroundImage: 'url(\''+ s3url(property.mainImage, 'small') +'\')'}" @click="$router.push('/properties/' + property.propertyId)">
				</a>

				<!-- Info -->
				<div class="event-box__info">
					<!-- <span class="event-box__title">{{isMatch ? 'New match!' : 'New Property!'}}</span>
					<a href="#" v-if="showDismiss" class="mq-sm-hide event-box__dismiss-text" @click.prevent="dismiss(dismissId)">
						<span>Dismiss</span>
					</a>
					<a href="#" v-if="showDismiss" class="mq-sm-show event-box__dismiss-btn" @click.prevent="dismiss(dismissId)">
						<i class="ico ico-delete"></i>
					</a> -->
					<span class="event-box__name" @click="$router.push('/properties/' + property.propertyId)">{{propertyAddress(property)}}</span>
						<!-- <span class="mq-md-hidden event-box__status" v-if="isMatch">{{matches}} new {{matches === 1 ? 'match' : 'matches'}}</span> -->
						<span class="mq-md-hidden event-box__status">{{ propertyStatus }}</span>
					<br><span class="event-box__details">{{ price }}</span><span class="mq-md-hidden event-box__details-beds">&nbsp;&nbsp;{{ bedsAndType }}</span>
					 <!-- <span class="mq-md-show event-box__status" v-if="isMatch">{{matches}} new {{matches === 1 ? 'match' : 'matches'}}</span><span v-else class="mq-md-show event-box__status">{{ propertyStatus }}</span> -->
				</div>
			</div>

      <div class="event-box__more-btn__border-mobile"></div>

			<!-- Show actions -->
      <!-- <a href="#" class="event-box__more-btn" :class="{'event-box__more-btn--translate': showMore}" @click.prevent="toggleMore"><i class="ico ico-arrow"></i></a> -->
      <div class="booking-box__btn-wrapper">
        <button class="mdc-button mdc-button--raised" @click="$router.push('/properties/' + property.propertyId)">Edit</button>
      </div>

		</div>

		<!-- ACTIONS -->

			<div v-show="showMore" class="event-box__actions mdc-card__horizontal-block">
				<!-- Show less btn -->
				<a href="#" class="mq-sm-hide event-box__less-btn" @click.prevent="toggleMore"><i class="ico ico-arrow"></i></a>

				<!-- action btns -->
				<div class="event-box__btn-wrapper mdc-layout-grid">
				  <div class="mdc-layout-grid__inner">
				    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet">

					 </div>
				    <!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet">
						 <button class="mdc-button mdc-button--raised">Send email matches</button>
					 </div>
				    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet">
						 <button class="mdc-button mdc-button--raised">Send SMS matches</button> -->
					 <!-- </div> -->
					 <!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet">
						 <button class="mdc-button mdc-button--raised" @click.prevent="deleteProperty(property.id, arrayIndex)">Delete Property</button>
					 </div> -->

					<!-- <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet" v-if="property.rmUrl != '' && property.rmUrl != null">
						<a :href="property.rmUrl" target="_blank" class="mdc-button mdc-button--raised">Rightmove link</a>
					</div>
					<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-tablet" v-if="property.zooplaUrl != '' && property.zooplaUrl != null">
						<a :href="property.zooplaUrl" target="_blank" class="mdc-button mdc-button--raised">Zoopla link</a>
					</div> -->

				  </div>
				</div>
		</div>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import utils from '@/libs/mixins.js';

export default {
	props: {
		property: [Object, Array],
		arrayIndex: Number
	},
	data: function() {
		return {
			show: true,
			showMore: false,
			showSection: true
		}
	},
	mixins: [utils],
	 computed: {
		 propertyStatus: function() {
       if (!this.property.serviceType || !this.property.status || !this.$store.state.propertyLists.propertyStatus[this.property.serviceType] || !this.$store.state.propertyLists.propertyStatus[this.property.serviceType][this.property.status]) {
         return '';
       }
 			 return this.$store.state.propertyLists.propertyStatus[this.property.serviceType][this.property.status];
 		},
 		price: function() {
 			if (this.property.serviceType === 'sales') {
 			   return this.formatCurrency(this.property.price);
 			} else {
 				 return this.formatCurrency(this.property.price) + ' ' + (this.property.rentFrequency ? this.property.rentFrequency : '');
 			}
 		},
 		bedsAndType: function() {
 			var summary = ''
 		  if(this.property.bedrooms == 0) {
 			  summary += 'Studio';
 		  } else {
 				summary += ' ' + this.property.bedrooms + ' bedroom';
 			}
 			if (this.property.bedrooms !== 0) {
 				summary += ' ' + this.propertyTypeName(this.property.type).toLowerCase();
 			}
 		  return summary;
 	  }
 	},
    methods: {
    	toggleMore: function() {
			if (screen.width <= 479) {
				this.showSection = true
			} else {
				this.showSection = !this.showSection
			}
			this.showMore = !this.showMore;
    	}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/EventBox.vue